<template>
  <div>
    <ScrollForMore />
    <img
      class="absolute inset-0 h-auto min-h-eighty w-full object-cover"
      width="1935"
      height="2128"
      src="@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-motorsport-racing-lifestyle-sports-budapest-hungary-europe-worldwide-ferrari-red-sportscar-hypercar-trackday-milancsizmadia-2.jpg"
      alt="" />
    <div
      class="relative mb-44 h-fifty md:mb-24 md:h-seventy lg:mb-20 lg:h-screen"></div>
    <div class="relative">
      <section class="px-2 pb-1 md:px-4 md:pb-2 lg:px-8 lg:pb-4">
        <div class="flex flex-1 items-center">
          <div class="-m-px w-2/3">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-motorsport-racing-lifestyle-sports-budapest-hungary-europe-worldwide-porsche-gt2-rs-zengomotorsport-sportscar-trackday-milancsizmadia-3.jpg')
              "
              :imgWidth="'1673'"
              :imgHeight="'1115'"
              :imgAlt="''" />
          </div>
          <div class="w-1/3">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-motorsport-racing-lifestyle-sports-budapest-hungary-europe-worldwide-porsche-gt2-rs-zengomotorsport-sportscar-trackday-milancsizmadia-4.jpg')
              "
              :imgWidth="'1200'"
              :imgHeight="'1800'"
              :imgAlt="''" />
          </div>
        </div>
      </section>
      <section class="py-1 px-2 md:py-2 md:px-4 lg:py-4 lg:px-8">
        <div class="flex flex-1 items-center">
          <div class="w-1/2 pr-1 md:pr-2 lg:pr-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-motorsport-racing-lifestyle-sports-budapest-hungary-europe-worldwide-red-ferrari-scudeira-f1-formula1-hungaroring-grand-prix-pitlane.jpg')
              "
              :imgWidth="'1243'"
              :imgHeight="'1554'"
              :imgAlt="''" />
          </div>
          <div class="w-1/2 pl-1 md:pl-2 lg:pl-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-motorsport-racing-lifestyle-sports-budapest-hungary-europe-worldwide-mercedes-amg-gt-safety-car-f1-formula1-hungaroring-grand-prix-pitlane.jpg')
              "
              :imgWidth="'1333'"
              :imgHeight="'1666'"
              :imgAlt="''" />
          </div>
        </div>
      </section>
      <section class="py-1 md:py-2 lg:py-4">
        <div class="h-thirty w-full md:h-sixty">
          <LazyImgLoader
            :imgSrc="
              require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-lamborghini-huracan-green-trackday-hungaroring-motorsport-racing-livefast-lifestyle-sports-budapest-hungary-europe-worldwide-milancsizmadia-4.jpg')
            "
            :imgWidth="'3000'"
            :imgHeight="'2000'"
            :imgAlt="''" />
        </div>
        <div
          class="-mt-8 flex flex-1 items-center px-2 md:-mt-14 md:px-4 lg:-mt-28 lg:px-8">
          <div class="w-1/3 pr-1 md:pr-2 lg:pr-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-lamborghini-huracan-green-trackday-hungaroring-motorsport-racing-livefast-lifestyle-sports-budapest-hungary-europe-worldwide-milancsizmadia-2-2.jpg')
              "
              :imgWidth="'1200'"
              :imgHeight="'1500'"
              :imgAlt="''" />
          </div>
          <div class="mx-0.5 w-1/3 px-0.5 md:mx-1 md:px-1 lg:mx-2 lg:px-2">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-lamborghini-huracan-green-trackday-hungaroring-motorsport-racing-livefast-lifestyle-sports-budapest-hungary-europe-worldwide-milancsizmadia-5.jpg')
              "
              :imgWidth="'1200'"
              :imgHeight="'1500'"
              :imgAlt="''" />
          </div>
          <div class="w-1/3 pl-1 md:pl-2 lg:pl-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-lamborghini-huracan-green-trackday-hungaroring-motorsport-racing-livefast-lifestyle-sports-budapest-hungary-europe-worldwide-milancsizmadia-3-2.jpg')
              "
              :imgWidth="'1174'"
              :imgHeight="'1468'"
              :imgAlt="''" />
          </div>
        </div>
      </section>
      <section class="py-1 md:py-2 lg:py-4">
        <div class="h-auto w-full">
          <LazyImgLoader
            :imgSrc="
              require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-motorsport-racing-lifestyle-sports-budapest-hungary-europe-worldwide-bmw-m6-gt3-racingcar-belgium-spa-francorchamps-endurance-total-24h-milancsizmadia.com.jpg')
            "
            :imgWidth="'2297'"
            :imgHeight="'1188'"
            :imgAlt="''" />
        </div>
      </section>
      <section class="py-1 px-2 md:py-2 md:px-4 lg:py-4 lg:px-8">
        <div class="flex flex-1 items-center pb-1 md:pb-2 lg:pb-4">
          <div class="w-1/2 pr-1 md:pr-2 lg:pr-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-motorsport-racing-lifestyle-sports-budapest-hungary-europe-worldwide-renault-f1-formula1-hungaroring-grand-prix-pitlane-daniel-ricciardo.jpg')
              "
              :imgWidth="'1234'"
              :imgHeight="'1543'"
              :imgAlt="''" />
          </div>
          <div class="w-1/2 pl-1 md:pl-2 lg:pl-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-classic-lamborghini-diablo-gold-trackday-spa-francorchamps-motorsport-racing-livefast-lifestyle-sports-budapest-hungary-europe-worldwide.jpg')
              "
              :imgWidth="'970'"
              :imgHeight="'1213'"
              :imgAlt="''" />
          </div>
        </div>
        <div class="flex flex-1 items-center pt-1 md:pt-2 lg:pt-4">
          <div class="w-1/2 pr-1 md:pr-2 lg:pr-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-bmw-m4-gt4-trackday-hungaroring-motorsport-racing-livefast-lifestyle-sports-budapest-hungary-europe-worldwide.jpg')
              "
              :imgWidth="'961'"
              :imgHeight="'1201'"
              :imgAlt="''" />
          </div>
          <div class="h-auto w-1/2 pl-1 md:pl-2 lg:pl-4">
            <LazyImgLoader
              :imgSrc="
                require('@/assets/photos/automotive/milan-csizmadia-photography-videography-automotive-pitlane-haupt-racing-motorsport-racing-lifestyle-sports-budapest-hungary-belgium-europe-worldwide-mercedes-amg-gt-spa-francorchamps-endurance-total24h.jpg')
              "
              :imgWidth="'1370'"
              :imgHeight="'1712'"
              :imgAlt="''" />
          </div>
        </div>
      </section>
      <section class="pt-1 md:pt-2 lg:pt-4">
        <div class="h-auto w-full">
          <LazyImgLoader
            :imgSrc="
              require('@/assets/photos/automotive/milan-csizmadia-photography-automotive-motorsport-racing-lifestyle-sports-europe-worldwide-lamborghini-huracan-gt3-blackbull-racing-team-spa-francorchamps-belgium-endurance-total-24h.jpg')
            "
            :imgWidth="'2254'"
            :imgHeight="'1503'"
            :imgAlt="''" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ScrollForMore from '../../components/ScrollForMore.vue'
import LazyImgLoader from '../../components/LazyImgLoader.vue'

export default {
  name: 'Automotive',
  components: {
    ScrollForMore,
    LazyImgLoader
  }
}
</script>
